import { render, staticRenderFns } from "./NormalHeader.vue?vue&type=template&id=480ff7d2&scoped=true&"
import script from "./NormalHeader.vue?vue&type=script&lang=js&"
export * from "./NormalHeader.vue?vue&type=script&lang=js&"
import style0 from "./NormalHeader.vue?vue&type=style&index=0&id=480ff7d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ff7d2",
  null
  
)

export default component.exports